import React, { Component } from 'react'
import "./serviceinfo.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import 'antd/dist/antd.css';
import { getApiServiceInfo } from "../../axios/api"
import { UrlSearch } from '../../axios/localstorage';


export default class serviceinfo extends Component {


    state = {
        data:{},
        currentIndex:0,
        type:0,

        newsType:1,

        page:1,
        total:11,

        content:`<p> 	中科合创(北京)科技成果评价中心是我国科技成果评价领域的领军机构，是经科技部有关部门批准成立的全国第一家第三方专业科技成果评价机构，是工信部认定的国
        家军民融合科技评估机构，也是全国唯一一家与公安部科技信息所联合开展全国公安系统和社会公共安全领域科技成果评价的第三方专业评价机构。经过10年的发展，
        中科合创现拥有专职员工400余人，在全国拥有52个工作站和14个分中心，服务区域以北京为中心覆盖全国。 　　
        中科合创始终坚持“专业、权威、客观、公正”的理念，与科技部有关部门、中国标准化研究院等单位共同起草制定了多项有关科技成果评价的国家标准和行业标准，
        率先在国内实现了评价结论的“可追溯、可查询”，成为我国科技成果评价行业内重大成果评价案例最多、评价结论认可度最高的第三方专业成果评价机构。</p>`,
    }

    componentWillMount(){

        window.scroll(0,0);

    }

    componentDidMount(){
        let id = UrlSearch('id');
        this.getInfo(id);
    }   

    getInfo=(id)=>{
        let param = {
            id
        }

        getApiServiceInfo(param)
        .then( req =>{
            if(req.data.code === 1){
                this.setState({
                    data:req.data.data
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }


    gotoPage=(page)=>{
        this.props.history.push(page);
    } 

    gotochangeType=(type)=>{
        let name = "type"+type;
        let div = document.getElementById(name);
        let  h = div.offsetTop - 180;
        // console.log(h);
        window.scroll(0,h);
        this.setState({
            type
        })
    }


    render() {
        return (
            <div className='serviceinfo'>
                <Header type={4} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p className='i_point' onClick={()=>{this.gotoPage('/service')}}>服务机构</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>服务机构详情</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='hinfo'>
                    <div className='cen'>
                        <div className='main'>
                            <div className='mimg'>
                                <div className='logo' style={{backgroundImage:"url('"+this.state.data.logo_text+"')"}}></div>
                            </div>
                            <div className='mtext'>
                                <h2>{this.state.data.nickname}</h2>
                                <div>
                                    <p>机构性质：{this.state.data.nature} ｜ 成立时间：{this.state.data.esta_time}</p>
                                </div>
                                <div>
                                    <img alt="" src="/www/assets/imgs/dingwei.png" />
                                    <p>{this.state.data.mechanism}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='page'>
                    <div className='cen'>
                        <div className='main'>
                            <div className='ptype'>
                                <div className='pflex'>
                                    <div onClick={()=>{this.gotochangeType(0)}} className={this.state.type === 0?'pfi pf_active':"pfi"} style={this.state.type === 0?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                        <p>服务介绍</p>
                                        <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                    </div>
                                    <div onClick={()=>{this.gotochangeType(1)}} className={this.state.type === 1?'pfi pf_active':"pfi"} style={this.state.type === 1?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                        <p>联系信息</p>
                                        <div className='pcen'>
                                                    <img alt="" src="/www/assets/imgs/san.png" />
                                                </div>
                                    </div>
                                </div>
                            </div>

                            <div className='name' id="type0">
                            <img alt="" src="/www/assets/imgs/lei.png" />
                                <h2>服务介绍</h2>
                            </div>

                            <div className="cont" dangerouslySetInnerHTML={{
                                __html: this.state.data.info
                            }}></div>

                            <div className='name' id="type1">
                            <img alt="" src="/www/assets/imgs/lei.png" />
                                <h2>联系信息</h2>
                            </div>

                            <div className='info'>
                                <h2>电话：     {this.state.data.mobile} </h2>
                                <h2>{}</h2>
                                <h2>传真：  {this.state.data.fax} </h2>
                                <h2>{}</h2>
                                <h2>地址：  {this.state.data.address} </h2>
                                <h2>{}</h2>
                                <h2>邮编：  {this.state.data.zip_code} </h2>
                                <h2>{}</h2>
                                <p hidden={!this.state.data.infob}>* {this.state.data.infob} </p>
                            </div>

                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
